const translations = {
  navigation: {
    table: 'Tablica',
    customers: 'Klijenti',
    stats: 'Statistika',
    settings: 'Podešavanje',
    logout: 'Odjava'
  },
  label: {
    accept: 'Prihvaćam',
    or: 'ili',
    first_name: 'Ime',
    last_name: 'Prezime',
    location: 'Mjesto',
    address: 'Adresa',
    name: 'Naziv',
    person_name: 'Ime',
    phone: 'Telefon',
    email: 'Email',
    birthday: 'Rođendan',
    city: 'Grad',
    note: 'Bilješka',
    password: 'Lozinka',
    password_confirmation: 'Potvrda lozinke',
    search: 'Pretraživanje',
    category: 'Kategorija',
    allCustomers: 'Svi klijenti',
    organization: 'Ime tvrtke',
    chooseCurrency: 'Izaberite valutu',
    chooseCountry: 'Izaberite državu',
    businessPhone: 'Poslovni telefon',
    businessHours: 'Radno vrijeme',
    activate: 'Aktivirajte',
    deactivate: 'Deaktivirajte',
    today: 'Danas',
    categories: 'Kategorije',
    language: 'Jezik',
    stats: 'Statistika',
    employees: 'Djelatnici',
    account: 'Nalog',
    services: 'Usluge',
    materials: 'Materijali',
    originalProfit: 'Izvorna zarada',
    profile: 'Profil',
    delete: 'Izbriši',
    edit: 'Promijeni',
    newEmail: 'Novi email',
    repeatPassword: 'Potvrdi lozinku',
    change: 'Promijeni',
    addEmployee: 'Dodaj djelatnika',
    editEmployee: 'Uredi djelatnika',
    addCustomer: 'Dodaj klijenta',
    editCustomer: 'Uredi klijenta',
    newCategory: 'Nova kategorija',
    country: 'Država',
    currency: 'Valuta',
    about: 'O nama',
    unit: 'Jedinica',
    quantity: 'Količina',
    price: 'Cijena',
    discount: 'Popust',
    total: 'Ukupno',
    duration: 'Trajanje',
    pause: 'Pauza',
    material: 'Materijal',
    date: 'Datum',
    close: 'Zatvori',
    noDataAvailable: 'Nema dostupnih podataka',
    addMaterial: 'Dodaj materijal',
    editMaterial: 'Uredi materijal',
    addService: 'Dodaj uslugu',
    editService: 'Uredi uslugu',
    actions: 'Postupci',
    service: 'Usluga',
    serviceName: 'Ime usluge',
    materialName: 'Ime materijala',
    h: 'h',
    min: 'min',
    noPause: 'Nema pauze',
    ml: 'ml',
    g: 'g',
    none: 'Ništa',
    addCategory: 'Dodaj kategoriju',
    editCategory: 'Uredi kategoriju',
    requestedChange: 'Zatražena promjena',
    invitation: 'Poziv',
    view: 'Pregled',
    addAppointment: 'Dodaj termin',
    customer: 'Klijent',
    customerInfo: 'Podaci klijenta',
    customerHistory: 'Povijest dolazaka',
    noCustomer: 'Nema klijenata',
    manageOrganization: 'Administrator',
    from: 'Od',
    to: 'Do',
    topWorkers: 'Najbolji Djelatnici',
    perProfit: 'Po Zaradi',
    perCustomers: 'Po klijentima',
    created: 'Izradio',
    updated: 'Promijenio',
    profit: 'Zarada',
    appointments: 'Termini',
    notifications: 'Obavijesti'
  },
  dateTime: {
    months: 'Sij_Vel_Ožu_Tra_Svi_Lip_Srp_Kol_Ruj_Lis_Stu_Pro',
    days: 'Pon_Uto_Sri_Čet_Pet_Sub_Ned'
  },
  days: {
    0: 'Ponedjeljak',
    1: 'Utorak',
    2: 'Srijeda',
    3: 'Četvrtak',
    4: 'Petak',
    5: 'Subota',
    6: 'Nedjelja'
  },
  button: {
    back: 'Vrati se',
    login: 'Prijavi se',
    forgotPassword: 'Zaboravljena lozinka',
    facebookLogin: 'Facebook prijava',
    facebookConnect: 'Poveži se preko Facebook-a',
    facebookDisconnect: 'Odjavi se preko Facebook-a',
    register: 'Registriraj se',
    upload: 'Učitaj',
    remove: 'Ukloni',
    update: 'Ažuriraj',
    cancel: 'Otkaži',
    add: 'Dodaj',
    save: 'Spremi',
    submit: 'Prihvati',
    invite: 'Pozovi',
    resendInvitation: 'Obnovi poziv',
    loadMore: 'Učitaj više'
  },
  message: {
    cookiePolicy: 'Ova web stranica koristi \'kolačiće\'. Ukoliko nastavite sa pregledom web stranice pristajete na njihovu upotrebu.',
    somethingWentWrong: 'Ups! Došlo je do greške',
    loginFailed: 'Greška u prijavi. Provijerite svoje podatke',
    loginFailedEmailVerify: 'Greška u prijavi. Potvrdite svoju email adresu',
    login: 'Prijavi se',
    homepage: 'Početna stranica',
    register: 'Registrirajte se',
    forgottenPassword: 'Zaboravljena lozinka',
    facebookFailed: 'Neuspjelo povezivanje sa Facebook-om',
    checkYourEmail: 'Provijerite vaš email za dalje upute',
    mailNotFound: 'Željeni email nije pronađen',
    saveSuccess: 'Podaci spremljeni',
    saveFailed: 'Podaci nisu spremljeni',
    removed: 'Uklonjeno',

    areYouSure: 'Jeste li sigurni?',
    removeEmployee: 'Ova akcija briše djelatnika',
    removeService: 'Ova akcija briše uslugu',
    removeMaterial: 'Ova akcija briše materijal',
    removeCustomer: 'Ova akcija briše klijenta',
    removeCategory: 'Ova akcija briše kategoriju',
    removeAppointment: 'Ova akcija briše termin',
    badInvitation: 'Krivi poziv',
    invitationSent: 'Poziv poslan',
    joinedSalonize: 'Povezan sa Salonize',
    emailChanged: 'Email adresa je promijenjena',
    welcome: {
      welcomeSalonize: 'Dobro došli u Salonize!',
      followSteps: 'Slijedite upute.',
      firstStep: 'Prvo dodajte djelatnike. ',
      secondStep: 'Zatim dodajte usluge '
    },
    no_notifications: 'Nema novih obavijesti',
    hasBirthday: ' rođendan',
    passwordMismatch: 'Neodgovarajuća potvrda lozinke',
    emailTaken: 'Email adresa je zauzeta',
    missingLocation: 'Nedostaje mjesto.',
    noServices: 'Nema odabranih usluga'
  },
  languages: {
    en: 'English',
    rs: 'Српски',
    hr: 'Hrvatski',
    mk: 'Македонски',
    si: 'Slovenščina'
  },
  currencies: {
    eur: 'EUR',
    rsd: 'RSD',
    hrk: 'HRK',
    chf: 'CHF',
    gbp: 'GBP',
    usd: 'USD',
    all: 'ALL',
    bam: 'BAM',
    mkd: 'MKD'
  }
}

export default translations



// WEBPACK FOOTER //
// ./src/translations/hr.js